/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ gem_number: NonNullable<unknown> }} Dialog_Donate_Confirm_Gem_DescriptionInputs */

const en_dialog_donate_confirm_gem_description = /** @type {(inputs: Dialog_Donate_Confirm_Gem_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• This donation will not affect your personal real tree planting count.
• You can only donate once. Are you sure you want to spend ${i?.gem_number} Time Crystals to donate?`)
};

const ar_dialog_donate_confirm_gem_description = /** @type {(inputs: Dialog_Donate_Confirm_Gem_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• لن يؤثر هذا التبرع على عدد الأشجار الحقيقية التي زرعتها شخصيًا. يمكنك التبرع مرة واحدة فقط. هل أنت متأكد
• أنك تريد إنفاق ${i?.gem_number} بلورة الزمن للتبرع؟`)
};

const de_dialog_donate_confirm_gem_description = /** @type {(inputs: Dialog_Donate_Confirm_Gem_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• Diese Spende hat keinen Einfluss auf deine persönliche Anzahl gepflanzter echter Bäume. 
• Du kannst nur einmal spenden. Bist du sicher, dass du ${i?.gem_number} Time Crystal ausgeben möchtest, um zu spenden?`)
};

const es_dialog_donate_confirm_gem_description = /** @type {(inputs: Dialog_Donate_Confirm_Gem_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• Esta donación no afectará tu recuento personal de árboles reales plantados. 
• Solo puedes donar una vez. ¿Estás seguro de que quieres gastar ${i?.gem_number} Cristal de tiempo para donar?`)
};

const fr_dialog_donate_confirm_gem_description = /** @type {(inputs: Dialog_Donate_Confirm_Gem_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• Ce don n'affectera pas votre nombre personnel d'arbres réels plantés. Vous ne
• pouvez donner qu'une seule fois. Êtes-vous sûr de vouloir dépenser ${i?.gem_number} Cristaux de temps pour faire un don ?`)
};

const it_dialog_donate_confirm_gem_description = /** @type {(inputs: Dialog_Donate_Confirm_Gem_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• Questa donazione non influirà sul tuo conteggio personale di alberi veri piantati.
• Puoi donare solo una volta. Sei sicuro di voler spendere ${i?.gem_number} Cristallo del Tempo per donare?`)
};

const ja_dialog_donate_confirm_gem_description = /** @type {(inputs: Dialog_Donate_Confirm_Gem_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• この寄付は、あなたがこれまでに植えた本物の樹木の数には影響しません。
• 寄付は一度しかできません。${i?.gem_number} 個の時の結晶を使って寄付してもよろしいですか？`)
};

const ko_dialog_donate_confirm_gem_description = /** @type {(inputs: Dialog_Donate_Confirm_Gem_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• 이 기부는 개인의 실제 나무 심기 횟수에 영향을 주지 않습니다. 기부는 한 번만 가능합니다.
• ${i?.gem_number} 타임 크리스탈을 사용하여 기부하시겠습니까?`)
};

const pt_br_dialog_donate_confirm_gem_description = /** @type {(inputs: Dialog_Donate_Confirm_Gem_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• Esta doação não afetará sua contagem pessoal de plantio de árvores reais. 
• Você só pode doar uma vez. Tem certeza de que deseja gastar ${i?.gem_number} Cristais do Tempo para doar?`)
};

const ru_dialog_donate_confirm_gem_description = /** @type {(inputs: Dialog_Donate_Confirm_Gem_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• Это пожертвование не повлияет на ваше личное количество посаженных настоящих деревьев. 
• Вы можете сделать пожертвование только один раз. Вы уверены, что хотите потратить ${i?.gem_number} Кристальное Время на пожертвование?`)
};

const th_dialog_donate_confirm_gem_description = /** @type {(inputs: Dialog_Donate_Confirm_Gem_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• การบริจาคนี้จะไม่ส่งผลต่อจำนวนการปลูกต้นไม้จริงส่วนบุคคลของคุณ
• คุณสามารถบริจาคได้เพียงครั้งเดียวเท่านั้น คุณแน่ใจหรือไม่ว่าต้องการใช้ ${i?.gem_number} คริสตัลแห่งกาลเวลา เพื่อบริจาค?`)
};

const tr_dialog_donate_confirm_gem_description = /** @type {(inputs: Dialog_Donate_Confirm_Gem_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• Bu bağış, kişisel gerçek ağaç dikme sayınızı etkilemeyecektir. Sadece bir kez bağış yapabilirsiniz. 
• Bağış yapmak için ${i?.gem_number} Zaman Kristali harcamak istediğinizden emin misiniz?`)
};

const zh_cn_dialog_donate_confirm_gem_description = /** @type {(inputs: Dialog_Donate_Confirm_Gem_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• 此活动不影响个人捐赠真树数量。
• 此活动只能捐献一次，确定要使用 ${i?.gem_number} 时光宝石进行捐献吗？`)
};

const zh_tw_dialog_donate_confirm_gem_description = /** @type {(inputs: Dialog_Donate_Confirm_Gem_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`• 此活動不影響個人捐贈真樹數量。
• 此活動只能捐獻一次，確定要使用 ${i?.gem_number} 時光寶石進行捐獻嗎？`)
};

/**
* | output |
* | --- |
* | "• This donation will not affect your personal real tree planting count. • You can only donate once. Are you sure you want to spend {gem_number} Time Crystals..." |
*
* @param {Dialog_Donate_Confirm_Gem_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_donate_confirm_gem_description = /** @type {((inputs: Dialog_Donate_Confirm_Gem_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Donate_Confirm_Gem_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_donate_confirm_gem_description(inputs)
	if (locale === "ar") return ar_dialog_donate_confirm_gem_description(inputs)
	if (locale === "de") return de_dialog_donate_confirm_gem_description(inputs)
	if (locale === "es") return es_dialog_donate_confirm_gem_description(inputs)
	if (locale === "fr") return fr_dialog_donate_confirm_gem_description(inputs)
	if (locale === "it") return it_dialog_donate_confirm_gem_description(inputs)
	if (locale === "ja") return ja_dialog_donate_confirm_gem_description(inputs)
	if (locale === "ko") return ko_dialog_donate_confirm_gem_description(inputs)
	if (locale === "pt_br") return pt_br_dialog_donate_confirm_gem_description(inputs)
	if (locale === "ru") return ru_dialog_donate_confirm_gem_description(inputs)
	if (locale === "th") return th_dialog_donate_confirm_gem_description(inputs)
	if (locale === "tr") return tr_dialog_donate_confirm_gem_description(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_donate_confirm_gem_description(inputs)
	return zh_tw_dialog_donate_confirm_gem_description(inputs)
});